var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVectorJoin = function SvgVectorJoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1192,
    height: 1364,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#vector-join_svg__a)",
    strokeLinecap: "round",
    strokeWidth: 40,
    d: "M1206 28.998c-116.87-90.676-6.5 558.004-301.998 474.004-254.304-72.289-398.44-.041-282.502 168.498 262.726 381.92-808.002 234-564.502 672.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector-join_svg__a",
    x1: 579.974,
    x2: 1403.79,
    y1: 739.968,
    y2: 159.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1EB7"
  })))));
};
export default SvgVectorJoin;